import { render, staticRenderFns } from "./SelectEmailsModal.vue?vue&type=template&id=4532fcc4&scoped=true&"
import script from "./SelectEmailsModal.vue?vue&type=script&lang=js&"
export * from "./SelectEmailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectEmailsModal.vue?vue&type=style&index=0&id=4532fcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532fcc4",
  null
  
)

export default component.exports